export default "__VITE_ASSET__DNkreug2__"